<template>
    <Paper class="barcode-merge">
        <m-table
            ref="RegistrationTable"
            :pageTotal="pageTotal"
            :tableData="listData"
            :config="tableConfig"
            @pageChange="pageChange"
            @sizeChange="sizeChange"
            @search="search"
            @onSearchDataChange="onSearchDataChange"
            @getTableConfigList="getTableConfigList"
            @btn-event="goDetail"
            @cellClick="cellClick"
            @onSelectionChange="onSelectionChange">
            <template v-slot:page-module-btn>
                <div>
                    <el-button size="mini" type="primary" :disabled="selectionList.length === 0" @click="execute">执行</el-button>
                </div>
            </template>
        </m-table>
        <detail ref="detail"></detail>
    </Paper>
</template>

<script>
import Paper from '@/components/core/paper/Paper';
import mTable from '@/modules/sn/components/IdentityComponentCopy/Main';
import detail from './detail/Index';
import { executeStatus } from '@/modules/sn/api/lcbsManagement.js';
import { searchByDictCodes, batchOiTobExecute } from '@/modules/sn/api/systemManagementApi.js';
import { tableConfig } from './tableConfig.js';
import { cloneDeep } from 'lodash';
import { replace } from '@/modules/sn/utils/generalOption';
import { mapGetters } from 'vuex';
import { fetchEyeInfoLog } from '@/modules/sn/api/productProcess.js';
export default {
    name: 'scanBarCodeCenter',
    components: { Paper, mTable, detail },
    data() {
        return {
            pageTotal: 0, // 总条数
            listData: [], // 列表数据
            searchData: {}, // 搜索框数据
            tableConfig: {}, // 表格配置
            exportColumns: [], // 导出行
            dictObj: {},
            selectionList: []
        };
    },
    created() {
        this.tableConfig = this.setTableConfig();
       this.handleDicts();
    },
    computed: {
        ...mapGetters(['currentTenant'])
    },
    methods: {
        execute () {
            if (this.selectionList.length > 1) {
                this.$message.warning('请勾选单条数据！');
                return;
            }
            const params = {
                param: {
                    batchNo: this.selectionList[0].batchNo
                },
                tenantCode: this.currentTenant.tenantCode
            };
            batchOiTobExecute(params).then(res => {
                 if (res.code + '' === '0') {
                    this.$message.success('操作成功');
                    this.search(this.searchData);
                 }
            });
        },

        onSelectionChange(list) {
            this.selectionList = list;
        },

        // 列配置
        getTableConfigList(data) {
            this.exportColumns = data;
        },
        // 动态设置配置行
        setTableConfig() {
            const newConfig = cloneDeep(tableConfig);
            return newConfig;
        },
        // 检查输入参数
        checksSearchData(data) {
            const arr = Object.values(data);
            const flag = arr.some(item => item);
            if (!flag) {
                this.$message.warning('请输入查询条件');
            }
            return flag;
        },
        onSearchDataChange(data) {
            this.searchData = data;
        },
        pageChange(pageNo) {
            this.tableConfig.page.pageNo = pageNo;
            this.search(this.searchData);
        },
        sizeChange(pageSize) {
            this.tableConfig.page.pageNo = 1;
            this.tableConfig.page.pageSize = pageSize;
            this.search(this.searchData);
        },
        // 查询
        search(data) {
            const flag = this.checksSearchData(data);
            flag && this.getData(data);
        },
        getData(data) {
            const params = {
                param: cloneDeep(data),
                tenantCode: this.currentTenant.tenantCode
            };
            params.param.pageSize = this.tableConfig.page.pageSize;
            params.param.pageNo = this.tableConfig.page.pageNo;
            this.listData = [];
            executeStatus(params).then((res) => {
                if (res.code + '' === '0' && res.data) {
                    this.pageTotal = res.data.totalCount;
                    this.listData = res.data.list.map(item => {
                        item.shipOrgType = this.dictObj.SN_LBCS_SHIP_ORG_TYPE[item.shipOrgType];
                        item.recOrgType = this.dictObj.SN_LBCS_SHIP_ORG_TYPE[item.recOrgType];
                        item.processFlag = item.processFlag === 'Y' ? '是' : '否';
                        item.receiverDetailAddrDees = item.receiverDetailAddr ? replace(item.receiverDetailAddr) : '';
                        item.senderDetailAddrDees = item.senderDetailAddr ? replace(item.senderDetailAddr) : '';
                        return item;
                    });
                }
            });
        },

        goDetail(row, index) {
            this.$refs.detail.open(row.batchId);
        },
        // 单元格点击查询全部单元格信息
        cellClick(data) {
            this.listData.some(item => {
                if (item.batchId === data.batchId) {
                    if (data.property.indexOf('Dees') > -1) {
                        const key = item[data.property.replace('Dees', '')];
                        if (item[data.property] !== key) {
                            if (!key) return;
                            item[data.property] = key;
                            const params = {
                                model: '条码中间表',
                                describe: `查看${data.label}`,
                                result: 'successful',
                                action: 'acces',
                                url: '/barcode/batchOiTob/page'
                            };
                            fetchEyeInfoLog(params);
                                return true;
                        } else {
                            item[data.property] = replace(key);
                        }
                    }
                }
            });
        },
        handleDicts() {
            const params = {
                dictCodes: 'SN_LBCS_SHIP_ORG_TYPE'
            };
            searchByDictCodes(params).then((res) => {
                if (res && res.data) {
                    Object.keys(res.data).forEach((key) => {
                        const obj = {};
                        res.data[key].forEach((item) => {
                            obj[item.code] = item.name;
                        });
                        this.dictObj[key] = obj;
                    });
                }
            });
        }
    }
};
</script>

<style lang="less" scoped>
.barcode-merge {
    /deep/ .el-table {
        height: calc(100vh - 200px) !important;
    }
}
</style>
